import { useEffect, useRef } from 'react';
import { Overlay } from '@alf/uikit';
import { LOG_ACTIONS, logNewRelicAction } from '@namespace/analytics';
import { useComponentConfig } from '@namespace/cms';
import { useHistory } from '@namespace/router';
import Loader from '../Loader';

import styles from './index.module.css';

const logRedirectAction = (redirectType) => {
  if (redirectType == null) {
    return;
  }

  logNewRelicAction(LOG_ACTIONS.REDIRECT, { redirectType });
};

export const RedirectComponent = () => {
  const { redirectLink, logRedirectType, preserveSearch } =
    useComponentConfig();
  const { push } = useHistory();
  const pushRef = useRef(push);

  useEffect(() => {
    pushRef.current = push;
  }, [push]);

  useEffect(() => {
    if (redirectLink == null) {
      return;
    }

    logRedirectAction(logRedirectType);

    const link = preserveSearch
      ? redirectLink + window.location.search
      : redirectLink;

    pushRef.current(link);
  }, [logRedirectType, preserveSearch, redirectLink]);

  return (
    <div className={styles.wrapper}>
      <Overlay classNames={{ wrapperClass: styles.overlay }}>
        <Loader />
      </Overlay>
    </div>
  );
};
